import styled from "styled-components"

export const NavBarWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
`;

export const LinkButton = styled.button`
  background-color: ${props => props.selected ? "#0091df" : "#4b88b1"}; 
  border: none; 
  border-radius: 5px; 
  color: #ffffff; 
  display: inline; 
  font-size: 12px; 
  letter-spacing: 2px; 
  margin-right: 1.1%; 
  padding: 1.5%; 
  text-align: center; 
  width: 30%; 
`;
